import { get, post } from './http-calls';

export const getTCardsCashAccounts = async () => {
    const res = await get(`TCardCashAccounts/TCards_GetCashAccounts`, { useAuthToken: true });
    return res;
};

export const postTCards_CashAccountAddUpdate = async (data) => {
    let res = await post(`TCardCashAccounts/TCards_CashAccountAddUpdate`, data, { useAuthToken: true });
    return res;
};

export const deleteTCardsCashAccounts = async (cashAccountID, data) => {
    let res = await post(`TCardCashAccounts/TCards_CashAccountDelete?CashAccountID=${cashAccountID}`, data, { useAuthToken: true });
    return res;
};